<template>
  <div
    class="arrow-button-navigation-wrapper"
    @click="handleClick"
  >
    <button
      class="arrow-button-navigation"
      :style="cssVars"
    >
      <MIcon
        :icon="arrowBackSmoothIcon"
        class="arrow-icon"
      />
    </button>
  </div>
</template>

<script>
  import MIcon from 'components/Design/MIcon';
  import ArrowBackSmoothIcon from 'assets/icons/arrow-back-smooth.svg';

  export default {
    name: 'ArrowButtonNavigation',
    components: {
      MIcon
    },
    props: {
      size: {
        type: Number,
        default: 40
      },
      colorBorder: {
        type: String,
        default: 'rgba(25, 25, 25, 0.45)'
      },
      colorIcon: {
        type: String,
        default: '#191919'
      }
    },
    data () {
      return {
        arrowBackSmoothIcon: ArrowBackSmoothIcon
      };
    },
    computed: {
      cssVars () {
        return {
          '--size': `${this.size}px`,
          '--color-border': this.colorBorder,
          '--color-icon': this.colorIcon
        };
      }
    },
    methods: {
      handleClick () {
        this.$emit('click');
      }
    }
  };
</script>

<style scoped>
  .arrow-button-navigation-wrapper {
    cursor: pointer;

    display: inline-flex;
  }

  .arrow-button-navigation {
    cursor: pointer;

    display: flex;

    justify-content: center;
    align-items: center;

    width: var(--size);
    height: var(--size);

    padding: 0;

    margin: 0;

    background-color: transparent;

    border: 1px solid var(--color-border);

    border-radius: 10px;

    outline: none;

    opacity: 1;

    transition: opacity 400ms cubic-bezier(0.34, 0.09, 0.34, 0.83), box-shadow 300ms;

    &:hover {
      opacity: 0.5;

      transition: opacity 50ms
        cubic-bezier(0.34, 0.09, 0.34, 0.5),
        box-shadow 300ms;
    }
  }

  .arrow-icon {
    color: var(--color-icon);

    width: calc(var(--size) * 0.6);
    height: calc(var(--size) * 0.6);
    pointer-events: none;
  }
</style>
